// components/Partners.js (New component)
import React from 'react';
import './Partners.css';
import { images } from '../utils/images';

const Partners = () => {
  return (
    <section className="partners">
      <div className="container">
        <h2 className="section-title">Our Partners</h2>
        <p className="section-subtitle">Working together for greater impact</p>
        <div className="partners-grid">
          {images.partners.map((partner, index) => (
            <div key={index} className="partner-logo">
              <img src={partner} alt={`Partner ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;